import { render, staticRenderFns } from "./MyquestionListCard.vue?vue&type=template&id=0714a6bd&"
import script from "./MyquestionListCard.vue?vue&type=script&lang=js&"
export * from "./MyquestionListCard.vue?vue&type=script&lang=js&"
import style0 from "./MyquestionListCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports